import React, { useState , useEffect } from 'react';
import { useSelector } from 'react-redux';
import './IV_REMS.css'; // 외부 스타일을 정의한 CSS 파일을 가져옵니다.
import Modal from 'react-modal'; // Modal 임포트 추가
import { getIvFieldValue } from '../../utils/ivErrorDataUtils';



Modal.setAppElement('#root'); // Accessibility 설정

const IV_REMS = ({ SelInverter }) => {

  const ivData = useSelector((state) => state.ivData || {});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [Ivstate, setIvstate] = useState('⚫');

  // 🔴🟢⚫

  useEffect(() => {
    const stateValue = getIvFieldValue(ivData, "state", SelInverter);

    if (stateValue !== undefined) {
      if (stateValue === 0) {
        setIvstate('🟢'); // 정상 상태
      } else if (stateValue === 1) {
        setIvstate('⚫'); // 대기 상태
      } else {
        setIvstate('🔴'); // 에러 상태
      }

    } else {
      setIvstate('🟢'); // state 값이 없을 경우
    }
  }, [ivData, SelInverter]);
  


  

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };


  return (
    <div>

      <div
        className='errorCodeBox'
        onClick={openModal}

        onMouseEnter={(e) => e.target.style.backgroundColor = '#0056b3'} // 마우스 오버 시 색상 변경 (짙은 파란색)
        onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--brand-navy, #013c8f)'} // 마우스가 떠나면 원래 색상으로
      >
        👉 REMS 상태보기 <span className="emoji-animation">{Ivstate}</span> {/* 이모지에 애니메이션 추가 */}

      </div>

      {/* 모달 */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Error Modal"
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
          content: {
            margin: 'auto',
            width: '80%',
            height: '80%',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            overflowX: 'auto',
          },
        }}
      >
        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>인버터 상태</h2>
        <BitDisplay SelInverter={SelInverter} />

        <button
          onClick={closeModal}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            fontSize: '18px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          닫기
        </button>
      </Modal>
    </div>
  );
};

export default IV_REMS;






const BitDisplay = ({ SelInverter }) => {

  const ivData = useSelector((state) => state.ivData || {});
  const errorValue = getIvFieldValue(ivData, "Error", SelInverter, 0);


  // Error 비트를 처리하는 함수
  const getBitStatus = (value, bitPosition) => {
    return (value & (1 << bitPosition)) !== 0;
  };

  // 셀 색상에 따라 클래스를 동적으로 설정하는 함수
  const getCellClassGood = (value, bitPosition) => {
    return getBitStatus(value, bitPosition) ? 'white-cell' : 'green-cell';
  };

  // 셀 색상에 따라 클래스를 동적으로 설정하는 함수
  const getCellClassBad = (value, bitPosition) => {
    return getBitStatus(value, bitPosition) ? 'yellow-cell' : 'white-cell';
  };

  return (
    <div>
      <table className="styled-table">

        <tbody>
          <tr className="header">
            <td><strong>Bit 0<br/>인버터 동작유무</strong></td>
            <td><strong>Bit 1<br/>태양전지 과전압</strong></td>
            <td><strong>Bit 2<br/>태양전지 저전압</strong></td>
            <td><strong>Bit 3<br/>태양전지 과전류</strong></td>
            <td><strong>Bit 4<br/>인버터 IGBT 에러</strong></td>
            <td><strong>Bit 5<br/>인버터 과온</strong></td>
            <td><strong>Bit 6<br/>계통 과전압</strong></td>
            <td><strong>Bit 7<br/>계통 저전압</strong></td>
          </tr>
          <tr>
            <td className={getCellClassGood(errorValue, 0)}>0 동작중</td>
            <td className={getCellClassGood(errorValue, 1)}>0 정상</td>
            <td className={getCellClassGood(errorValue, 2)}>0 정상</td>
            <td className={getCellClassGood(errorValue, 3)}>0 정상</td>
            <td className={getCellClassGood(errorValue, 4)}>0 정상</td>
            <td className={getCellClassGood(errorValue, 5)}>0 정상</td>
            <td className={getCellClassGood(errorValue, 6)}>0 정상</td>
            <td className={getCellClassGood(errorValue, 7)}>0 정상</td>
          </tr>
          <tr>
            <td className={getCellClassBad(errorValue, 0)}>1 미작동</td>
            <td className={getCellClassBad(errorValue, 1)}>1 과전압</td>
            <td className={getCellClassBad(errorValue, 2)}>1 저전압</td>
            <td className={getCellClassBad(errorValue, 3)}>1 과전류</td>
            <td className={getCellClassBad(errorValue, 4)}>1 에러</td>
            <td className={getCellClassBad(errorValue, 5)}>1 과온</td>
            <td className={getCellClassBad(errorValue, 6)}>1 과전압</td>
            <td className={getCellClassBad(errorValue, 7)}>1 저전압</td>
          </tr>
        </tbody>
      </table>

      <table className="styled-table" style={{ marginTop: '10px' }}>
        <tbody>
          <tr className="header">
            <td><strong>Bit 8<br/>계통 과전류</strong></td>
            <td><strong>Bit 9<br/>계통 과주파수</strong></td>
            <td><strong>Bit 10<br/>계통 저주파수</strong></td>
            <td><strong>Bit 11<br/>단독운전 (정전)</strong></td>
            <td><strong>Bit 12<br/>지락 (누전)</strong></td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
          </tr>
          <tr>
            <td className={getCellClassGood(errorValue, 8)}>0 정상</td>
            <td className={getCellClassGood(errorValue, 9)}>0 정상</td>
            <td className={getCellClassGood(errorValue, 10)}>0 정상</td>
            <td className={getCellClassGood(errorValue, 11)}>0 정상</td>
            <td className={getCellClassGood(errorValue, 12)}>0 정상</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
          </tr>
          <tr>
            <td className={getCellClassBad(errorValue, 8)}>1 과전류</td>
            <td className={getCellClassBad(errorValue, 9)}>1 과주파수</td>
            <td className={getCellClassBad(errorValue, 10)}>1 저주파수</td>
            <td className={getCellClassBad(errorValue, 11)}>1 정전</td>
            <td className={getCellClassBad(errorValue, 12)}>1 누전</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

// export default BitDisplay;
